import { UntypedFormGroup, UntypedFormControl, FormGroup } from "@angular/forms";
import { Subscription } from 'rxjs';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { UUID } from 'angular2-uuid';
import { PricingRangeBus } from '@app/cp/shared/models/PricingRangeBus';
import { SearchTarget } from "../enums/SearchTarget";
import { PricingTypeEnum } from "../enums/PricingTypeEnum";
import { GItem } from "../models/GItem";
import { HttpHeaders } from "@angular/common/http";
import { FileInfo } from "@progress/kendo-angular-upload";

export class CommonFunctions {
    public static hasStringValue(value: string): boolean {
        return value !== undefined && value !== null && value.trim().length > 0 ? true : false;
    }
    public static hasStringValueLength(value: string, len: number = 0): boolean {
        return value !== undefined && value !== null && value.trim().length >= len ? true : false;
    }
    public static hasNumberValue(value: number): boolean {
        return value !== undefined && value !== null && value !== 0 ? true : false;
    }
    public static hasNumberValueIncludingZero(value: number): boolean {
        return value !== undefined && value !== null  ? true : false;
    }
    public static stringContains(value: string, valueContained: string): boolean {
        return value !== undefined && value !== null && value.trim().length > 0 && value.includes(valueContained);
    }
    public static Round(d: number): number {
        var val = Math.round(d * 100) / 100;
        return val;
    }
    public static RoundUp(d: number): number {
        var val = Math.ceil(d * 100) / 100;
        return val;
    }
    public static RoundToPrecision(nbr: number, precision: number): number {
        var val = 0;
        if (precision == 3)
            val = Math.round(nbr * 1000) / 1000;
        else if (precision == 4)
            val = Math.round(nbr * 10000) / 10000;
        else
            val = Math.round(nbr * 100) / 100;
        return val;
    }

    public static CalculateCost(ratio: number, flatCost: number, currentCost: number, lastCost: number, avgCost: number, type: PricingTypeEnum): number {
        var cost: number = 0;
        if (ratio == 0)
            ratio = 1;
        if (flatCost > 0)
            cost = flatCost / ratio;
        else if (type == PricingTypeEnum.Highest)
            cost = currentCost > lastCost ? currentCost / ratio : lastCost / ratio;
        else if (type == PricingTypeEnum.Average)
            cost = avgCost / ratio;
        else if (type == PricingTypeEnum.CurrentCost)
            cost = currentCost / ratio;
        return cost;
    }
    public static validateForm(form: UntypedFormGroup): boolean {
        if (!form.valid) {
            /* if you are using angular 8 or above, you can just do form.markAllAsTouched() which will touch
               all the fields without having to loop through all the fields and mark it as touched.
            */
            for (let i in form.controls) {
                form.controls[i].markAsTouched();
            }
            return false;
        }
        else {
            return true;
        }
    }

    public static CalculateMarkup(cost: number, ranges: PricingRangeBus[]): number {
        var val = 0;
        //ranges.forEach((r) => {
        // if (r.low <= cost && r.high >= cost)
        // return r.markup;
        //});
        for (let r of ranges) {
            if (r.low <= cost && r.high >= cost) {
                return r.markup;
            }
        }
        return val;
    }
    public static hasArrayValue(value: any): boolean {
        return Array.isArray(value) && value.length > 0 ? true : false;
    }
    public static arrayLength(value: any): number {
        return Array.isArray(value) && value.length > 0 ? value.length : 0;
    }
    public static hasArrayElementValue(value: any, element: number = 0): boolean {
        return Array.isArray(value) && value.length > element && this.hasValue(value[element]) ? true : false;
    }
    public static getStringValueIfNull(value: any, valueIfNull: string = ""): string {
        let retVal: string = valueIfNull;
        if (this.hasStringValue(value)) {
            retVal = value;
        }
        return retVal;
    }
    public static getNumberValue(value: any): number {
        let retVal: number = 0;
        try {
            retVal = parseFloat(value);
        }
        catch (err) {
            retVal = 0;
        }
        return retVal;
    }
    public static getBoolValueIfNull(value: any, valueIfNull: boolean = false): boolean {
        let retVal: boolean = valueIfNull;
        if (this.hasValue(value)) {
            retVal = value;
        }
        return retVal;
    }
    public static getArraySubstringValue(array: any, element: number, substrVal: number, defaultVal: any) {
        let retVal: any = null;
        try {
            retVal = array[element].substr(substrVal);
        }
        catch {
            retVal = defaultVal;
        }
        return retVal;
    }
    public static removeValueFromGItemArray(array: GItem[], guid: string) {
        var index: number = -2;
        var localArray = [];
        guid = guid.toLowerCase();
        if (array && array.length > 0) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].value != guid) {
                    localArray.push(array[i]);
                }
            }
        }
        return localArray;
    }
    public static getArrayFromCommaDelimitedString(data: string): any[] {
        let arr: any[] = [];
        if (this.hasStringValue(data)) {
            arr = data.split(',');
        }
        return arr;
    }
    public static getCommaDelimitedStringFromArray(arr: string[]): string {
        let str: string = null;
        if (this.hasArrayElementValue(arr)) {
            str = arr.join(',');
        }
        return str;
    }
    public static getDate(data: any): Date {
        let ret: Date = null;
        if (CommonFunctions.hasValue(data)) {
            ret = new Date(data);
        }
        return ret;
    }
    public static getDateNow(): Date {
        let dateNow: Date = new Date(Date.now());
        return dateNow;
    }
    public static unsubscribe(subs: Subscription) {
        if (subs !== undefined && subs !== null) {
            subs.unsubscribe();
        }
    }
    public static hasValue(data: any): boolean {
        return data !== undefined && data !== null ? true : false;
    }
    public static isEmptyChar(data: any): boolean {
        return data !== "" ? true : false;
    }
    public static isGuid(data: any): boolean {
        let retVal: boolean = this.hasValue(data) && data.toString().length == 36 && data != '00000000-0000-0000-0000-000000000000' ? true : false;
        return retVal;
    }
    public static hasGuidValue(data: any): boolean {
        let retVal: boolean = this.hasValue(data) && data != '00000000-0000-0000-0000-000000000000' ? true : false;
        return retVal;
    }
    public static getGuidValueOrEmpty(data: any): any {
        let retVal: any = this.hasGuidValue(data) ? data : '00000000-0000-0000-0000-000000000000';
        return retVal;
    }
    public static getGuidValueOrNull(data: any): any {
        if (data === '00000000-0000-0000-0000-000000000000') {
            return null;
        }
        return data;
    }
    //  public static getGuidNullValueIfStringEmpty(data: any): any {
    //      if (data  ) {
    //          return null;
    //      }
    //      return data;
    //  }
    public static validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
        Object.keys(formGroup.controls).forEach(field => {  //{2}
            const control = formGroup.get(field);             //{3}
            if (control instanceof UntypedFormControl) {             //{4}
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof UntypedFormGroup) {        //{5}
                CommonFunctions.validateAllFormFields(control);            //{6}
            }
        });
    }
    public static cityStateZip(city: string, state: string, zip: string): string {
        let ret: string = "";
        if (this.hasStringValue(city) && this.hasStringValue(state) && this.hasStringValue(zip)) {
            ret = city.trim() + ", " + state.trim() + " " + zip.trim();
        }
        return ret;
    }

    public static calculateProfit(cost: number, sold: number): number {
        let res: number = 0;
        let tmpCost = CommonFunctions.getNumberValue(cost);
        let tmpSold = CommonFunctions.getNumberValue(sold);
        res = (tmpSold - tmpCost);
        return res;
    }
    public static calculateProfitPct(cost: number, sold: number): number {
        let res: number = 0;
        let profit: number = CommonFunctions.calculateProfit(cost, sold);
        if (profit !== 0) {
            res = profit / sold;
        }
        return res;
    }
    public static formatMoney(value: number) {
        let cp: CurrencyPipe = new CurrencyPipe('en-US');
        return cp.transform(value, 'USD', 'symbol', '1.2-2');
    }
    public static formatPct(value: number) {
        let pp: PercentPipe = new PercentPipe('en-US');
        return pp.transform(value, '1.2-2');
    }
    public static getGuid(): string {
        return UUID.UUID();
    }
    public static getFileNameWithoutExtension(name: string): string {
        let fileName: string = name;
        if (this.hasStringValue(name)) {
            let arr: string[] = name.split('.');
            fileName = arr[0];
        }
        return fileName;
    }
    public static GetDQOIItemCode(target: SearchTarget): string {
        let code: string = "1"; //Dispatch
        switch (target) {
            case SearchTarget.quote:
                code = "2";
                break;
            case SearchTarget.order:
                code = "3";
                break;
            case SearchTarget.invoice:
                code = "4";
                break;
            case SearchTarget.contract:
                code = "9";
                break;
            case SearchTarget.job:
                code = "10";
                break;
        }
        return code;
    }
    public static copyToClipboard(val: string) {
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        var a = document.execCommand('copy');
        document.body.removeChild(selBox);
    }
    //Semi Colon Delimited
    public static validateEmails(emails: string): boolean {
        let ok: boolean = true;
        var arrEmails = emails.split(';');
        for (let i = 0; i < arrEmails.length; i++) {
            if (CommonFunctions.validateEmail(arrEmails[i].trim()) == false) {
                ok = false;
                break;
            }
        }
        return ok;
    }
    public static validateEmail(email) {
        const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regularExpression.test(String(email.trim()).toLowerCase());
    }
    public static hasValidValue(data: any): boolean {
        return this.hasValue(data) && this.isEmptyChar(data) ? true : false;
    }

    public static setAuthorizationHeader(headers: HttpHeaders, token: string): HttpHeaders {
        return headers.set('Authorization', 'Bearer ' + token);
    }

    public static sanitizeSpecialCharacters(data: string) {
        return data.match(/[a-z0-9._\-\s]/gi).join('')
    }

    /**
     * Patch the form with the attachment
     *
     * @static
     * @param {FileInfo} file
     * @param {FormGroup<any>} form
     * @return {*}  {void}
     * @memberof CommonFunctions
     */
    public static patchEditFormWithAttachment(file: FileInfo, form: FormGroup<any>): void {
        if (!file?.rawFile) {
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = (reader.result as string).split(',')[1];
            form.patchValue({
                attachment: base64String,
                attachmentType: file.extension,
                attachmentName: file.name.replace(file.extension, "")
            });
        };
        reader.readAsDataURL(file.rawFile);
    }

    /**
    * Find a value or values in an array of items
    * @param {any} arr
    * @param {any} val
    * @return {string[]}
    * @memberof CommonFunctions
    */
    public static findInObjArr(arr: any, val: any) {
        let returnVal = [];
        if (arr && val) {
            if (typeof (val) === 'object' && !Array.isArray(val)) {                
                returnVal = val.reduce((acc, element) => {
                    let found = arr.find(o => o.value === element);
                    if (found) {
                        acc.push(found.description);
                    }
                    return acc;
                }, []);
                return returnVal;
            } else if (Array.isArray(val)) {                
                returnVal = val.reduce((acc, element) => {
                    let found = arr.find(o => o.value === element);
                    if (found) {
                        acc.push(found.description);
                    }
                    return acc;
                }, []);
                return returnVal;
            } else if (val) {                
                returnVal = arr.reduce((acc, o) => (o.value === val ? o.description : acc), []);
                return [returnVal];
            } else {
                return returnVal;
            }
        } else {
            return returnVal;
        }
    }
}
